import React, { useEffect, useRef, useState } from "react";
import LoadingScreen from "react-loading-screen";
import Fileupload from "../../components/Fileupload";
import { toast } from "react-toastify";
import {
  excel_dita,
  fileDelete,
  get_prev_files,
  getdownload,
  upload_file,
} from "../../api/api";
import Modal from "../../components/Modal";
import PreviousFiles from "../../components/PreviousFiles";

const Exceltodita = () => {
  const [selectedData, setSelectedData] = useState();
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [fileToDelete, setFileToDelete] = useState();
  const [prevfiles, setPrevFiles] = useState([]);
  const [downloadingFile, setDownloadingFile] = useState([]);
  const [formData, setFormData] = useState({});
  const [valueData, setValueData] = useState([]);
  const [emptyFiles, setEmptyFiles] = useState(0);
  const [errors, setErrors] = useState({});
  const [fileResult, setFileResult] = useState({});
  const dropdownRefs = useRef({});
  let fetchInterval;
  useEffect(() => {
    fetchprevfile("excel_to_dita");
  }, []);

  const process = "excel_to_dita";
  // const validateForm = () => {
  //   const newErrors = {};
  //   apiData.forEach(({ name }) => {
  //     console.log(formData[name], "ggs");

  //     if (!formData[name] || formData[name].trim() === "") {
  //       newErrors[name] = `${name.replace(/_/g, " ")} is required`;
  //     }
  //   });
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.keys(fileResult).length === 0) {
      if (!selectedData) return;
      // if (!validateForm()) return;
      setIsSubmitted(true);

      try {
        setLoading(true);
        const result = await upload_file(selectedData);
        setLoading(false);
        if (result.data) {
          setIsSubmitted(false);
          toast.success("The file process completed.");
          fetchprevfile("excel_to_dita");
          startFetching("excel_to_dita");
          setEmptyFiles(1);
          setFileResult(result.data);

          setSelectedData();
        }
      } catch (e) {
        setLoading(false);
        toast.error(e || "An error Occurred");
      } finally {
        setLoading(false);
        setIsSubmitted(false);
      }
    } else {
      setIsSubmitted(true);
      try {
        const result = await excel_dita(formData, fileResult.id);
        if (result.data) {
          setIsSubmitted(false);
          toast.success("The process completed.");
          fetchprevfile("excel_to_dita");
          startFetching("excel_to_dita");
          setFileResult({});
          setValueData([]);
          setFormData({});
        }
      } catch (e) {
        toast.error(e || "An error Occurred");
      } finally {
        setIsSubmitted(false);
      }
    }
  };

  const fetchprevfile = async (process) => {
    try {
      let data = await get_prev_files(process);
      if (data) {
        setPrevFiles(data.data);
         if (!(data.data.some(item => item.status === "1"))) stopFetching(); //fetch untill condition
      } else {
        toast.error(data.error.message);
      }
    } catch (e) {
      toast.error(e);
    }
  };

   const startFetching = (process, interval = 15000) => {
    if (fetchInterval) return; // prevent multiple intervals
    
    fetchInterval = setInterval(() => {
      fetchprevfile(process);
      console.log("Starting fetch interval");
    }, interval);
  };

  const stopFetching = () => {
    if (fetchInterval) {
      clearInterval(fetchInterval);
      fetchInterval = null;
      console.log("Stopping fetch interval");
    }
  };

  const handleDownload = async (fileid, process) => {
    setDownloadingFile((prev) => [...prev, fileid]);
    try {
      let data = await getdownload(fileid, process);
      if (data.data) {
        downloadreport(data.data.content, data.data.file_name);
      }
    } catch (e) {
      toast.error(e);
    } finally {
      setDownloadingFile((prev) => prev.filter((id) => id !== fileid));
    }
  };

  const handleFileDelete = async (fileid, filename) => {
    setShowModal(true);
    setFileToDelete({ fileid: fileid, filename: filename });
  };

  const downloadreport = (data, filename) => {
    try {
      const file = data;
      const byteCharacters = atob(file);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      // console.log(byteArrays);
      const blob = new Blob(byteArrays, { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      downloadfile(url, filename);
    } catch (e) {
      console.log(e);
    }
  };

  const downloadfile = (url, filename) => {
    if (url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `${filename}`;
      link.click();
      toast.success("File downloaded successfully");
      // Clean up the URL object
      window.URL.revokeObjectURL(url);
    } else {
      // alert("No File to Download");
      toast.info("No Files to Download");
    }
  };

  const confirmFileDelete = async () => {
    if (fileToDelete) {
      let response = await fileDelete(fileToDelete.fileid, "excel_to_dita");
      if (response.data) {
        fetchprevfile("excel_to_dita");
      } else {
        // alert(response.error.message);
        toast.error(response.error.message);
      }
    }
  };
  const handleSelectChange = (e, key) => {
    const selectedName = e.currentTarget.dataset.name;

    setFormData((prev) => {
      const prevSelected = prev[key]; // old value(s)

      if (key === "data_tag") {
        // Toggle selection
        const selectedArray = Array.isArray(prevSelected)
          ? prevSelected.includes(selectedName)
            ? prevSelected.filter((name) => name !== selectedName) // remove if already selected
            : [...prevSelected, selectedName] // add if not selected
          : [selectedName];

        // Update valueData for visual toggle
        setValueData((prevValueData) =>
          prevValueData.map((item) =>
            item.name === selectedName ? { ...item, value: !item.value } : item
          )
        );

        return { ...prev, [key]: selectedArray };
      } else {
        // Single selection logic
        setValueData((prevValueData) =>
          prevValueData.map((item) => {
            if (item.name === selectedName) {
              return { ...item, value: true }; // mark new selection
            } else if (item.name === prevSelected) {
              return { ...item, value: false }; // unmark previous selection
            }
            return item;
          })
        );

        setSelectDropOpen({});
        return { ...prev, [key]: selectedName };
      }
    });
  };

  // const handleSelectChange = (e, key) => {
  //   const selectedName = e.currentTarget.dataset.name;

  //   setFormData((prev) => {
  //     const prevSelected = prev[key]; // old value(s) for this dropdown

  //     if (key === "data_tag") {
  //       const newSelected = Array.isArray(prevSelected)
  //         ? prevSelected.includes(selectedName)
  //           ? prevSelected.filter((name) => name !== selectedName)
  //           : [...prevSelected, selectedName]
  //         : [selectedName];

  //       setValueData((prevValueData) =>
  //         prevValueData.map((item) =>
  //           item.name === selectedName ? { ...item, value: !item.value } : item
  //         )
  //       );

  //       return { ...prev, [key]: newSelected };
  //     } else {
  //       setValueData((prevValueData) =>
  //         prevValueData.map((item) => ({
  //           ...item,
  //           value: item.name === selectedName,
  //         }))
  //       );
  //       setSelectDropOpen({});
  //       return { ...prev, [key]: selectedName };
  //     }
  //   });
  // };

  //   const handleSelectChange = (e, key) => {
  //   const selectedName = e.currentTarget.dataset.name;

  //   setFormData((prev) => {
  //     const prevSelected = prev[key]; // old value(s)

  //     if (key === "data_tag") {
  //       // Multiple selection allowed
  //       const selectedArray = Array.isArray(prevSelected)
  //         ? prevSelected.includes(selectedName)
  //           ? prevSelected.filter((name) => name !== selectedName) // deselect
  //           : [...prevSelected, selectedName] // add selection
  //         : [selectedName];

  //       // Toggle value in valueData
  //       setValueData((prevValueData) =>
  //         prevValueData.map((item) =>
  //           item.name === selectedName ? { ...item, value: !item.value } : item
  //         )
  //       );

  //       return { ...prev, [key]: selectedArray };
  //     } else {
  //       // Single selection
  //       setValueData((prevValueData) =>
  //         prevValueData.map((item) => {
  //           if (item.name === selectedName) {
  //             return { ...item, value: true }; // mark new selection
  //           } else if (item.name === prevSelected) {
  //             return { ...item, value: false }; // unmark previous selection
  //           }
  //           return item;
  //         })
  //       );

  //       setSelectDropOpen({}); // close dropdown if needed
  //       return { ...prev, [key]: selectedName };
  //     }
  //   });
  // };

  useEffect(() => {
    if (Object.keys(fileResult).length > 0) {
      setFormData(
        fileResult.col_names.reduce((acc, name) => {
          if (name) {
            acc[name] = "";
          }
          return acc;
        }, {})
      );
      setValueData(
        fileResult.excel_heading.map((item) => ({ name: item, value: false }))
      );
    }
  }, [fileResult]);

  const [selectDropOpen, setSelectDropOpen] = useState({});

  const selectDropdown = (index) => {
    setSelectDropOpen((prev) => ({
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      Object.entries(dropdownRefs.current).forEach(([key, ref]) => {
        if (ref && !ref.contains(event.target)) {
          setSelectDropOpen((prev) => ({ ...prev, [key]: false }));
        }
      });
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <LoadingScreen
      loading={loading}
      bgColor="#f1f1f1"
      spinnerColor="#1A53A9"
      textColor="#1A53A9"
      text="Processing file please wait ...."
    >
      <div className="h-full w-full flex flex-col">
        <div className="p-8 flex flex-col gap-8 h-[100%]">
          <div className="text-left">
            <h1 className="text-24 font-semibold">Excel To DITA Conversion</h1>
          </div>
          {valueData.length > 0 && (
            <div className="w-full  mx-auto grid grid-cols-2 bg-white border border-grey-200 rounded-[24px] gap-10  p-5">
              {fileResult?.col_names?.map((data, i) => (
                <div
                  key={i}
                  className="flex justify-start gap-5"
                >
                  <p
                    className={`overflow-hidden text-start capitalize font-semibold text-[16px] w-1/3 flex justify-between items-center ${
                      true ? "text-black" : "text-dimtext"
                    }`}
                  >
                    {data}
                  </p>
                  <div
                    ref={(el) => (dropdownRefs.current[i] = el)}
                    className="relative w-2/3"
                  >
                    {/* Dropdown Button */}
                    <div
                      className="schemadropdown bg-white border-[1px] border-commonborder rounded-[12px] px-3 py-3 w-full text-left flex justify-between items-center text-dimtext"
                      onClick={() => selectDropdown(i)}
                    >
                      <p
                        className={`w-full overflow-hidden  ${
                          true ? "text-black" : "text-dimtext"
                        }`}
                      >
                        {formData[data]
                          ? Array.isArray(formData[data])
                            ? formData[data].join(", ")
                            : formData[data]
                          : "choose Option"}
                      </p>
                      <span className="ml-2">
                        {!selectDropOpen[i] ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.293 9.293a1 1 0 011.414 0L10 12.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M14.707 10.707a1 1 0 01-1.414 0L10 7.414l-3.293 3.293a1 1 0 11-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                        )}
                      </span>
                    </div>

                    {/* Dropdown Menu */}
                    {selectDropOpen[i] && (
                      <ul
                        // ref={schemaref}
                        className="absolute z-10 bg-white border border-gray-300 rounded-lg w-full mt-2 shadow-lg max-h-[300px] overflow-auto"
                      >
                        {valueData?.map((option, index) => (
                          <li
                            data-name={option.name}
                            key={index}
                            disabled={option.value}
                            className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                              option.value ? "bg-gray-100" : ""
                            }`}
                            onClick={(e) => {
                              if (option.value && data !== "data_tag") return;
                              handleSelectChange(e, data);
                            }}
                          >
                            {option.name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
          {Object.keys(fileResult).length === 0 && (
            <>
              <Fileupload
                key={emptyFiles}
                // file={files}
                // setFiles={setFiles}
                setSelectedData={setSelectedData}
                category={"3"}
                emptyfile={emptyFiles}
              />
            </>
          )}

          <div className="w-full text-right flex gap-4 justify-end mt-10 mb-10">
            {/* <button
              className="py-2 px-5 border-[1px] rounded-lg border-commonborder text-btntext"
              onClick={() => confirmFileDelete()}
            >
              cancel
            </button> */}
            <button
              className="py-2 px-5 bg-highlighttext rounded-lg text-white"
              type="submit"
              onClick={(e) => handleSubmit(e)}
              disabled={isSubmitted}
            >
              {isSubmitted ? "Processing" : "Submit"}
            </button>
          </div>
          {Object.keys(fileResult).length === 0 && (
            <PreviousFiles
              prevfiles={prevfiles}
              handleDownload={handleDownload}
              handleFileDelete={handleFileDelete}
              process={process}
              downloadingFile={downloadingFile}
            />
          )}
        </div>
      </div>
      {/* {showValidationModal && (
        <Modal
          title={"Alert"}
          body={
            "Do you wish to continue the processing in the Background and continue to Dashboard ?"
          }
          setShow={setShowValidationModal}
          setConfirm={runInBg}
          setSecondary={runInloading}
          cancelbtn={"Cancel"}
          confirmbtn={"Run in Background"}
          secondarybtn={"Continue to Loading screen"}
          // setbackground={setRunInBackground}
        />
      )} */}
      {showModal && (
        <div>
          <Modal
            title={"Alert"}
            body={`Do you wish to delete file ${fileToDelete?.filename} ?`}
            setShow={setShowModal}
            setConfirm={confirmFileDelete}
            confirmbtn={"Confirm"}
            cancelbtn={"Cancel"}
          />
        </div>
      )}
    </LoadingScreen>
  );
};

export default Exceltodita;
